

import Spinner from 'vux/src/components/spinner/index.vue'

import PulldownLayer from './PulldownLayer';
window.onscroll = function() {
return document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
}
export default {
props: {
value: { // 上拉 下拉 加载状态
type: Object,
default: () => {
},
},
usePullup: { // 是否启用上拉加载 默认不启用
type: Boolean,
default: false,
},
usePulldown: { // 是否启用下拉加载 默认不启用
type: Boolean,
default: false,
},
scrollOffset: {
type: Number,
default: 60,
},
infinity: {
type: Boolean,
default: true,
},
height: {
type: [Number, String],
default: '',
},
loadingType: {
type: String,
default: '',
},
},
activated() {
if (this.scrollTop && this.vScroller) {
this.vScroller.scrollTop = this.scrollTop;
}
},
computed: {
angle() {
const deg = Math.max(0, Math.abs(Math.min(-this.offsetTop / 1.3, 100))) / 100 * 360;
return deg > 180 ? 180 : deg;
},
},
data() {
return {
status: this.value,
offsetNo: 0.3, // 偏移系数
offsetTop: 0, // 容器偏移量
scrollTop: 0,
scrollContentHeight: 0, // 滚动容器的高度
touchStartOffset: 0, // 手指按下时在屏幕上的位置
activeDown: false, // 激活下拉
activeUp: false, // 激活上拉
pullupEnable: this.usePullup, // 是否启用上拉
pulldownEnable: this.usePulldown, // 是否启用下拉
vScrollerDownStyle: {
transform: '',
transition: '',
},
vScrollerUpStyle: {
transform: '',
transition: '',
},
vScrollerBottomTop: 0,
};
},
filters: {},
watch: {








},
mounted() {
this.$nextTick(() => {
this.vScroller = this.$refs.vScroller;
this.vScrollerBody = this.$refs.vScrollerBody; 
this.vScrollerContent = this.$refs.vScrollerContent; 
this.vScrollerBottomTop = this.$refs.vScrollerBottom;

this.vScroller.addEventListener('touchstart', this.touchStart);
this.vScroller.addEventListener('touchmove', this.touchMove);
this.vScroller.addEventListener('touchend', this.touchEnd);

if (this.checkiOS()) { // iOS
const body = document.body;
body.addEventListener('touchmove', (e) => {
if (e.pageY <= 0 || e.pageY > document.body.clientHeight) {
const events = document.createEvent('touchEvent');
events.initEvent('touchend', true, true);
this.vScroller.dispatchEvent(events);
}
});
}


if (this.infinity) {
let nowScrollTop = 0; 
this.vScroller.onscroll = () => {
if (!this.pullupEnable) {
return;
}
const bodyHeight = this.vScroller.clientHeight; 
const scrollHeight = this.vScroller.scrollHeight; 
const scrollTop = this.vScroller.scrollTop; 
if (nowScrollTop > scrollTop) {
nowScrollTop = scrollTop;
return;
}
nowScrollTop = scrollTop;
if (scrollHeight !== bodyHeight && scrollHeight - bodyHeight - scrollTop <= 50 && this.status.upStatus === 'default') {
this.status.upStatus = 'loading';
this.$emit('on-pullup-loading');
}
};
}
});
},
methods: {

checkiOS() {
return /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(navigator.userAgent);
},

offsetContent(top) {
this.vScrollerDownStyle.transform = `translate3d(0px, ${top}px, 0px)`;
this.vScrollerDownStyle.top = `translate3d(0px, ${top}px, 0px)`;
if (this.status.upStatus === 'up' || this.status.upStatus === 'loading' || this.infinity) {
this.vScrollerUpStyle.transform = `translate3d(0px, ${top}px, 0px)`;
}
},

resetOffset(offset) {
if (this.infinity && offset < 0) { // 如果是无限滚动 则复位的时候直接为0
offset = 0;
}
const t = 300;
this.offsetContent(offset || 0);
this.vScrollerDownStyle.transition = `transform ${t}ms ease-in-out`;
this.vScrollerUpStyle.transition = `transform ${t}ms ease-in-out`;
setTimeout(() => {
this.vScrollerDownStyle.transition = '';
this.vScrollerUpStyle.transition = '';
this.offsetTop = 0;
}, t);
},

touchStart(e) {
this.touchStartOffset = e.targetTouches[0].clientY; 

this.listContentHeight = this.vScroller.scrollHeight; 
this.scrollContentHeight = this.vScroller.clientHeight; 
},

touchMove(e) {
console.log(this.scrollBottom());
if (this.scrollBottom() >= 80) return false;
if (this.status.downStatus === 'loading' || this.status.upStatus === 'loading') {
e.preventDefault();
return;
}
this.offsetTop = e.targetTouches[0].clientY - this.touchStartOffset; 
this.offsetTop *= this.offsetNo;
const scrollTop = this.vScroller.scrollTop; 
this.scrollTop = scrollTop;
if (this.usePulldown && this.pulldownEnable && this.offsetTop > 0 && scrollTop === 0) { // 下拉，并且容器滚动到顶部的时候
e.preventDefault();
this.offsetContent(this.offsetTop);
this.$emit('on-scroll', 0 - this.offsetTop); 
this.status.downStatus = 'down';
this.activeDown = true;
} else {
this.activeDown = false;
}
const reduce = this.listContentHeight - this.scrollContentHeight; 
if (this.offsetTop < 0 && (((scrollTop - 1 < reduce || reduce < scrollTop + 1) && scrollTop >= reduce - 1) || this.listContentHeight <= this.scrollContentHeight)) { // 上拉，并且容器滚动到底部的时候
e.preventDefault();
if (this.usePullup && this.pullupEnable) {
this.activeUp = true;
this.status.upStatus = 'up';
this.offsetContent(this.offsetTop);
}
} else {
this.activeUp = false;
}
},

touchEnd() {
this.isTouch = false;
if (!this.activeUp && !this.activeDown) {

return;
}
if (this.offsetTop > 0 && this.pulldownEnable && this.status.downStatus !== 'loading') { // 下拉达到临界点，激活刷新
if (this.offsetTop > this.scrollOffset && this.activeDown) {
this.resetOffset(this.scrollOffset);
this.status.downStatus = 'loading';
this.$emit('on-pulldown-loading');
} else {
this.status.downStatus = 'default';
this.resetOffset();
}
}
if (this.offsetTop < 0 && this.pullupEnable && this.status.upStatus !== 'loading') { // 上拉达到临界点，激活刷新
if (Math.abs(this.offsetTop) > this.scrollOffset && this.activeUp) {
this.resetOffset(-this.scrollOffset);
this.status.upStatus = 'loading';
if (this.scrollBottom() <= 80) this.$emit('on-pullup-loading');
} else {
this.status.upStatus = 'default';
this.resetOffset();
}
}
},

donePulldown() {
this.resetOffset();
this.status.downStatus = 'default';
this.activeDown = false;
},

donePullup() {
this.resetOffset();
this.status.upStatus = 'default';
this.activeUp = false;

if (this.checkiOS() && this.vScroller.scrollHeight <= this.vScroller.clientHeight) {
this.vScroller.style['-webkit-overflow-scrolling'] = 'auto';
setTimeout(() => {
this.vScroller.style['-webkit-overflow-scrolling'] = 'touch';
}, 0);
}
},
disablePullup() {
this.pullupEnable = false;
},
enablePullup() {
this.pullupEnable = true;
},
disablePulldown() {
this.pulldownEnable = false;
},
enablePulldown() {
this.pulldownEnable = true;
},
scrollBottom() {

return document.documentElement.scrollHeight - document.documentElement.clientHeight - window.onscroll();
}
},
components: {
Spinner,
PulldownLayer,
},
};
